import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ServerResponse } from '../models/types.model';
import {
  IAdminUserCreatePayload,
  IAdminUserListResponse,
  IAdminUserUpdatePayload,
  ICurrentAdminUserResponse
} from '../models/admin-access.model';

@Injectable({
  providedIn: 'root'
})
export class AdminUserService extends HttpService {
  constructor() {
    super();
  }

  // Seule route de l'API Admin ouverte à tout compte authentifié : un compte
  // sans rôle doit pouvoir apprendre qu'il n'a accès à rien.
  async me(): Promise<ICurrentAdminUserResponse> {
    return this.get('/me') as Promise<ICurrentAdminUserResponse>;
  }

  async list(): Promise<IAdminUserListResponse> {
    return this.get('/admin-users') as Promise<IAdminUserListResponse>;
  }

  async create(payload: IAdminUserCreatePayload): Promise<ServerResponse> {
    return this.post('/admin-users/new', payload) as Promise<ServerResponse>;
  }

  async update(userName: string, payload: IAdminUserUpdatePayload): Promise<ServerResponse> {
    return this.put('/admin-users/' + encodeURIComponent(userName), payload);
  }

  async signOut(userName: string): Promise<ServerResponse> {
    return this.post('/admin-users/' + encodeURIComponent(userName) + '/sign-out') as Promise<ServerResponse>;
  }
}
